import { FC } from 'react';

import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import { AddBannerButton } from 'components/Banners/components/AddBannerButton';
import { Banner } from 'components/Banners/components/Banner/Banner';

import { useSelector } from 'store/utils';

export const Banners: FC = () => {
    const banners = useSelector((state) => state.banners.banners);
    const campaign = useSelector((state) => state.banners.campaign);

    if (!campaign) {
        return null;
    }

    const hasOnlyOneEnabledBanner = banners.filter((banner) => banner.enabled).length === 1;

    return (
        <GridLayout>
            <GridRow>
                <GridColumn xs={4} s={8} m={10} l={8}>
                    <AddBannerButton campaignId={campaign.id ?? 0} campaignStatus={campaign.frontendStatus} />
                    {banners.map((banner) => (
                        <Banner
                            key={banner.id}
                            banner={banner}
                            campaign={campaign}
                            hasOnlyOneEnabledBanner={hasOnlyOneEnabledBanner}
                            singleBanner={banners.length === 1}
                        />
                    ))}
                </GridColumn>
            </GridRow>
        </GridLayout>
    );
};
